export default __webpack_public_path__ + "static/media/instagram-icon-pink.8353d0db.svg";